import { Canvas, useFrame } from "@react-three/fiber";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTexture } from "@react-three/drei";
import * as THREE from "three";
import axios from "axios";

const Scene = ({ vertex, fragment, scale }) => {
  const meshRef = useRef();

  // Load the noise texture and update the shader uniform
  const noiseTexture = useTexture("noise2.png");
  useFrame((state) => {
    let time = state.clock.getElapsedTime();

    // start from 20 to skip first 20 seconds ( optional )
    meshRef.current.material.uniforms.iTime.value = time + 20;
  });

  // Define the shader uniforms with memoization to optimize performance
  const uniforms = useMemo(
    () => ({
      iTime: {
        type: "f",
        value: 1.0,
      },
      iResolution: {
        type: "v2",
        value: new THREE.Vector2(200,200),
      },
      iChannel0: {
        type: "t",
        value: noiseTexture,
      },
    }),
    []
  );

  return (
      <mesh ref={meshRef}>
        <planeGeometry args={[scale, scale]} />
        <shaderMaterial
          uniforms={uniforms}
          vertexShader={vertex}
          fragmentShader={fragment}
          side={THREE.DoubleSide}
        />
      </mesh>
  );
};

function Orb() {
  // State variables to store the vertex and fragment shaders as strings
  const [vertex, setVertex] = useState("");
  const [fragment, setFragment] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Check for mobile viewport
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Fetch the shaders once the component mounts
  useEffect(() => {
    // fetch the vertex and fragment shaders from public folder 
    axios.get("/vertexShader.glsl").then((res) => setVertex(res.data));
    axios.get("/fragmentShader.glsl").then((res) => setFragment(res.data));
  }, []);

  // If the shaders are not loaded yet, return null (nothing will be rendered)
  if (vertex == "" || fragment == "") return null;

  // Desktop: original styling
  if (!isMobile) {
    return (
      <div style={{zIndex:1, backgroundColor:"transparent", alignText:"center", height:"40vh"}}>
        <Canvas style={{ width: "80vw", height: "100vh", display: "inline"}}>
          <Scene vertex={vertex} fragment={fragment} scale={7} />
        </Canvas>
      </div>
    );
  }

  // Mobile: responsive styling
  return (
    <div style={{
      zIndex: 1,
      backgroundColor: "transparent",
      width: "100%",
      height: "280px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <Canvas style={{ width: "280px", height: "280px" }}>
        <Scene vertex={vertex} fragment={fragment} scale={5.5} />
      </Canvas>
    </div>
  );
}

export default Orb